import { logWrapper } from '../../utils';

export default {
  deleteModalController: [
    'runtimeConstant',
    '$scope',
    '$uibModal',
    'service',
    '$window',
    '$state',
    function (runtimeConstant, $scope, uibModal, service, $window, $state) {
      'use strict';

      function parent_cancelButton() {
        $scope.modalRemoveDocument.close();
        $scope.modalError.close();
        $window.location.reload();
      }

      function parent_deleteModel() {
        return new Promise(function (resolve) {
          for (var i = 0; i < $scope.itensDeleted.length; i++) {
            $scope.itensDeleted[i].loading = true;
          }
          service.delete($scope.itensDeleted).then(
            function () {
              for (var i = 0; i < $scope.itensDeleted.length; i++) {
                $scope.itensDeleted[i].removed = 1;
                $scope.itensDeleted[i].loading = false;
                $scope.itensDeleted[i].selected = false;
              }
              $scope.modalRemoveDocument.close();
              resolve();
              $state.reload();
            },
            function (err) {
              $scope.messageTitle = err.title;
              $scope.messageDescription = err.text;
              $scope.messageCancel = 'OK';

              $scope.modalError = uibModal.open({
                scope: $scope,
                animationEnabled: true,
                backdrop: 'static',
                templateUrl: '/views/modal/errorModal/errorModal.html',
                controller: 'deleteModalController',
                size: 'small',
                windowClass: 'modal-remove',
                resolve: {
                  service: () => service,
                },
              });
              $scope.modalError.close();
            }
          );
        });
      }

      function run() {
        try {
          $scope.$parent.cancelButton = logWrapper(
            parent_cancelButton,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.$parent.deleteModel = logWrapper(
            parent_deleteModel,
            runtimeConstant.isDebugControllersInternals
          );
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      logWrapper(run, runtimeConstant.isDebugControllers)();
    },
  ],
};
